import { render, staticRenderFns } from "./PurchaseGoodsList.vue?vue&type=template&id=1414aec9&scoped=true"
import script from "./PurchaseGoodsList.vue?vue&type=script&lang=js"
export * from "./PurchaseGoodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1414aec9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1414aec9')) {
      api.createRecord('1414aec9', component.options)
    } else {
      api.reload('1414aec9', component.options)
    }
    module.hot.accept("./PurchaseGoodsList.vue?vue&type=template&id=1414aec9&scoped=true", function () {
      api.rerender('1414aec9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/PurchaseGoodsList.vue"
export default component.exports